import { allFamilies, getFamily } from '../config/familyRegistry';
import { getActiveSystem } from '../config/system';

// Entity-type helpers (#139) — the plural route-style segments shared by the API
// (`/api/<entity_type>`), the frontend URLs (`/<entity_type>?slug=`), the
// favorites API's entity_type values, and the omnisearch results.
//
// This file used to carry its own copy of the ten segments and their labels,
// with a comment asking whoever edited it to keep it in sync with
// `server/routes/favorites.js` by hand. Both are now read from the Family
// registry (05 §R1), so a newly declared Family gets its label and its ordering
// with nobody editing anything.

/** Every entity_type with a nav position, in nav order. */
export function entityTypeOrder(systemSlug = getActiveSystem()) {
  return allFamilies(systemSlug).map((f) => f.segment);
}

/**
 * Human label for an entity_type ("spells" → "Spells").
 *
 * Unknown types echo back, which is the behaviour this has always had and is
 * what keeps an orphaned favorite (a Family since removed) rendering rather
 * than vanishing.
 */
export function entityTypeLabel(entityType, systemSlug = getActiveSystem()) {
  const family = entityType ? getFamily(entityType, systemSlug) : null;
  return family ? family.labels.plural : entityType;
}

/** List-route path for an entity_type ("spells" → "/spells"). */
export function entityTypePath(entityType) {
  return `/${entityType}`;
}
